import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { ViewState } from "../../../common/config/AppConstants";
import * as format from "../../../common/FormatFunctions";
import { ListValueDisplay } from "../../Common/ListValueDisplay";

export class WorkDisplay extends React.Component {
  render() {
    var bean = this.props.data;
    if (!format.isNotNull(bean)) {
      return <div></div>;
    }
    return (
      <div
        className="ui-g-12 card-round"
        onClick={e => {
          if (format.isFunction(this.props.onClick)) {
            this.props.onClick(bean);
          }
        }}
      >
        <div className="ui-g-12">
          {bean.metadata.extraProperty}
          <label />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Work/UI/WorkDisplay.js